<template>
  <div>
    <app-page>
      <template #fheader>
        <div class="fan-search margin-bottom-8">
          <jr-search2
            ref="searchForm"
            :form-list="formList"
            :search-value.sync="queryForm"
            :loading="loading"
            @search="handleSearch"
            @reset="handleReset"
          />
        </div>
      </template>
      <template #header>
        <div class="fan-search">
          <page-select-groups :search-value.sync="queryForm" @change="refreshList" :selectList="selectList" />
          <div class="fan-search-right">
            <div v-if="$has('FWS-DZZX-QDSXF-DC')">
              <page-export-button
                buttonText="导出"
                exportServe="fin_counting_channel_fee_report"
                :total="total"
                :isLimit="true"
                :exportParams="exportParams"
              />
            </div>
          </div>
        </div>
        <div class="radio-group" v-if="serviceTypeList && serviceTypeList.length>1">
          <el-radio-group v-model="queryForm.serviceType" @change="handleChangeType">
            <el-radio-button v-for="item in serviceTypeList" :key="item.value" :label="item.value">{{ item.label }}</el-radio-button>
          </el-radio-group>
        </div>
      </template>
      <template #main="{ height }">
        <jr-table
          :height="height"
          :key="height"
          :loading="loading"
          :tableData="list"
          :tableColumn="tableColumn"
        >
          <template v-slot:tradeAmount>
            <el-table-column label="收款" prop="receiptFeeAmount" min-width="1" align="center">
              <template slot-scope="{row}">
                {{ row.receiptFeeAmount | toFenThousandsAndFloat }}
              </template>
            </el-table-column>
            <el-table-column label="退款" prop="refundFeeAmount" min-width="1" align="center">
              <template slot-scope="{row}">
                {{ row.refundFeeAmount | toFenThousandsAndFloat }}
              </template>
            </el-table-column>
            <el-table-column label="付款" prop="paymentFeeAmount" min-width="1" align="center">
              <template slot-scope="{row}">
                {{ row.paymentFeeAmount | toFenThousandsAndFloat }}
              </template>
            </el-table-column>
            <el-table-column label="其他" prop="orderFeeAmount" min-width="1" align="center">
              <template slot-scope="{row}">
                {{ row.orderFeeAmount | toFenThousandsAndFloat }}
              </template>
            </el-table-column>
            <el-table-column label="总共" prop="tradeAmount" min-width="1" align="center">
              <template slot-scope="{row}">
                {{ row.tradeAmount | toFenThousandsAndFloat }}
              </template>
            </el-table-column>
          </template>
        </jr-table>
      </template>
      <template #ffooter>
        <pagination
          :total="total"
          :current-page="queryForm.page"
          :size="queryForm.limit"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </template>
    </app-page>
  </div>
</template>

<script>
import { getChannelFeeReport } from '@/api/counting';

const queryFormDefault = {
  page: 1,
  limit: 20,
  cuttingDateStart: '',
  cuttingDateEnd: '',
  merchantName: '',
  channelType: '',
  dateType: '1',
  transType: 2,
  serviceType: '', // 服务商类型: 1-百布服务商,2-一批商
};

export default {
  data() {
    return {
      loading: false,
      queryForm: { ...queryFormDefault },
      formList: [
        {
          prop: 'dateType',
          component: 'select-date-picker',
          options: [
            { label: '交易日期', value: '1' },
          ],
          dateProps: {
            beginTime: 'cuttingDateStart',
            endTime: 'cuttingDateEnd',
          },
        },
        {
          label: '交易主体',
          prop: 'merchantName',
          component: 'input',
          attrs: {
            placeholder: '请输入',
          },
        },
      ],
      list: [],
      total: 0,
      tableColumn: [
        { prop: 'cuttingDate', label: '交易日期', minWidth: '1', filterName: 'formatTime(yyyy-MM-dd)' },
        { prop: 'channelTypeDesc', label: '交易渠道', minWidth: '1' },
        { prop: 'merchantName', label: '交易主体', minWidth: '1' },
        { prop: 'startBalance', label: '期初余额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat' },
        { key: 'tradeAmount', label: '手续费发生金额(元)', minWidth: '1', isMultiColumn: true, multiColumnSlotName: 'tradeAmount', align: 'center' },
        { prop: 'endBalance', label: '期末余额(元)', minWidth: '1', filterName: 'toFenThousandsAndFloat' },
      ],
      selectList: [
        {
          title: '交易渠道',
          prop: 'channelType',
          dictionaryPath: '/finance/finance-counting/CountingChannelEnum',
        },
      ],
      serviceTypeList: [], // 服务商类型集合
    };
  },
  computed: {
    exportParams() {
      const params = {
        ...this.queryForm,
      };
      delete params.page;
      delete params.limit;
      return params;
    },
  },
  created() {
    const list = [];
    this.queryForm.serviceType = '';
    if (this.$has('FWS-DZZX-QDSXF-BBFWS')) {
      list.push({ value: '1', label: '百布服务商' });
      this.queryForm.serviceType = '1';
    }
    if (this.$has('FWS-DZZX-QDSXF-YPFWS')) {
      list.push({ value: '2', label: '一批商' });
      this.queryForm.serviceType = this.queryForm.serviceType || '2';
    }
    this.serviceTypeList = list;
    this.getList();
  },
  methods: {
    // 切换服务商类型
    handleChangeType() {
      this.queryForm.page = 1;
      this.getList();
    },
    // 列表查询
    handleSearch(params = {}) {
      this.queryForm = { ...this.queryForm, ...params, page: 1 };
      this.getList();
    },
    // 重置搜索条件
    handleReset() {
      this.queryForm = { ...queryFormDefault };
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        const params = { ...this.queryForm };
        delete params.dateType;
        const res = await getChannelFeeReport(params);
        this.total = res.totalCount || 0;
        this.list = res.data || [];
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.total = 0;
        this.loading = false;
      }
    },
    // 分页操作
    handleCurrentChange(page) {
      this.queryForm.page = page;
      this.getList();
    },
    handleSizeChange(limit) {
      this.queryForm.page = 1;
      this.queryForm.limit = limit;
      this.getList();
    },
    refreshList() {
      this.queryForm.page = 1;
      this.getList();
    },
  },
};
</script>

